import { useEffect, useMemo, useState } from 'react';
import {
    useLoadScript,
    GoogleMap,
    MarkerF,
    CircleF,
} from '@react-google-maps/api';
import Link from 'next/link';
import Image from 'next/image';
import { FaArrowLeft } from 'react-icons/fa';
import { useRouter } from 'next/router';
import MetaHeader from '../src/components/MetaHeader';
import ClientLayout from '../src/layouts/client/ClientLayout';
import { titleContactUsHeader } from '../src/components/MockData/MockData';
import BookingFormContact from '../src/components/BookingFormContact';
import PlacesAutocompleteContact from '../src/components/PlaceAutocompleteContact';
import { textConfig } from '../constants/textLang';
import { contactEvent } from '../utils/facebookPixelEvent';
import thumborLoader from '../utils/thumborLoader';

const Contact = () => {
    useEffect(() => {
        contactEvent();
    }, []);
    const router = useRouter();
    const [address, setAddress] = useState(null);
    const [addressSelect, setAddressSelect] = useState(null);
    const [lat, setLat] = useState(13.9242306);
    const [lng, setLng] = useState(100.4614971);

    const libraries = useMemo(() => ['places'], []);

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.GCP_GOOGLE_MAP_API_KEY,
        libraries: libraries,
    });

    if (!isLoaded) {
        return <p>Loading...</p>;
    }

    const callbackValueDropInput = (val) => {
        setAddress({ name: 'address', val: val });
        setAddressSelect({ title: val.address });
    };

    const routeIcon = (link) => {
        router.push(link);
    };

    return (
        <ClientLayout style={{ backgroundColor: 'black' }}>
            <section className="contact-page">
                <div className="contact-title">
                    <div className="contact-route">
                        <Link href={'/'} legacyBehavior>
                            <a className="btn-back">
                                <FaArrowLeft
                                    style={{
                                        color: '#DAA520',
                                        marginRight: '5px',
                                    }}
                                />
                                BACK TO OVERVIEW
                            </a>
                        </Link>
                    </div>

                    <div className="contact-title-text">
                        <h1>Contact us</h1>
                    </div>
                </div>
                <div className="contact-content">
                    <div className="conteact-content-wrapper">
                        <div className="contact-section-address">
                            <div className="address-header">
                                <p className="header-title">
                                    {titleContactUsHeader.en.addressTitle}
                                </p>
                            </div>
                            <div className="address-detail">
                                {titleContactUsHeader.en.addressDetail.map(
                                    (itemAddress, indexAddress) => (
                                        <div key={indexAddress}>
                                            <p>{itemAddress}</p>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                        <div className="contact-section-contact">
                            <div className="contact-header">
                                <p>{titleContactUsHeader.en.contactTitle}</p>
                            </div>
                            <div className="contact-list">
                                {titleContactUsHeader.en.contactDetail.map(
                                    (item, index) => (
                                        <div
                                            className="contact-list-item"
                                            key={index}
                                            onClick={() => routeIcon(item.link)}
                                        >
                                            <Image
                                                loader={thumborLoader}
                                                src={item.image}
                                                alt={item.alt}
                                                className="img-item"
                                                loading="lazy"
                                                width="30"
                                                height="30"
                                            />
                                            <div className="contact-list-title">
                                                <p className="title">
                                                    {item.title}
                                                </p>
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="contact-section-contact-form">
                        <div className="contact-form-header">
                            <p>{titleContactUsHeader.en.contactForm}</p>
                        </div>
                        <div>
                            <BookingFormContact
                                address={address}
                                addressSelect={addressSelect}
                            />
                        </div>
                    </div>
                </div>
                <div className="contact-section-map">
                    <PlacesAutocompleteContact
                        name={'drop_off_address'}
                        isLoaded={true}
                        label={'Drop off Adress'}
                        placeholder={'Drop off Adress'}
                        callbackValue={callbackValueDropInput}
                    />
                </div>
            </section>
        </ClientLayout>
    );
};

export const getStaticProps = async (ctx) => {
    const { locale } = ctx;
    const meta = {
        title: textConfig[locale]?.title_contact,
        keywords: textConfig[locale]?.text_keyword,
        description: 'Luxury29 Car Rental Contact Us Page',
        image: 'main-pic.jpeg',
    };

    return {
        props: { meta },
    };
};

export default MetaHeader(Contact);
